import clsx from "clsx";
import { Button, Container } from "src/components";

import "./OpinionBanner.scss";

interface OpinionBannerProps extends React.HTMLAttributes<HTMLDivElement> {}

export const OpinionBanner = (props: OpinionBannerProps): JSX.Element => {
  const { className } = props;

  return (
    <Container
      className={clsx(
        "opinion-banner inline-flex flex-col gap-6 text-center items-center flex-grow justify-center min-h-[450px]",
        className
      )}
    >
      <div className="opinion-banner_image">
        <img
          src={`${process.env.REACT_APP_PAGE_URL}images/opinion_character_complete.png`}
          alt=""
        />
      </div>
      <h2>NEED HELP WITH SOMETHING?</h2>
      <p className="text-xs">We're here for you!</p>
      <Button as="a" href={`mailto:${process.env.REACT_APP_OPINION_EMAIL}`}>
        <span className="text-sm">Get in touch</span>
      </Button>
    </Container>
  );
};
